import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import Technologies from './components/Technologies'
import Values from './components/Values'
import Process from './components/Process'
import Pricing from './components/Pricing'
import Documents from './components/Documents'
import Contact from './components/Contact'
import Footer from './components/Footer'
import PersonalData from './components/PersonalData'
import PrivacyPolicy from './components/PrivacyPolicy'
import CookieConsent from './components/CookieConsent'
import MathSin from './components/MathSin'

import navigation from '../content/navigation.json'
import hero from '../content/hero.json'
import about from '../content/about.json'
import services from '../content/services.json'
import technologies from '../content/technologies.json'
import values from '../content/values.json'
import process from '../content/process.json'
import pricing from '../content/pricing.json'
import documents from '../content/documents.json'
import contact from '../content/contact.json'
import footer from '../content/footer.json'
import okved from '../content/okved.json'
import personalData from '../content/personal-data.json'
import privacyPolicy from '../content/privacy-policy.json'
import seo from '../content/seo.json'
import cookieConsent from '../content/cookie-consent.json'

import { useSeo } from './hooks/useSeo'
import { useCookieConsent } from './hooks/useCookieConsent'

import type {
  Navigation, Hero as HeroType, About as AboutType, Services as ServicesType,
  Technologies as TechnologiesType, Values as ValuesType, Process as ProcessType,
  Pricing as PricingType, Documents as DocumentsType, Contact as ContactType,
  Footer as FooterType, Okved, PersonalDataPage as PersonalDataPageType,
  CookieConsent as CookieConsentType, PrivacyPolicyPage as PrivacyPolicyPageType
} from './types/content'

interface HomePageProps {
  onOpenCookieSettings: () => void
}

function HomePage({ onOpenCookieSettings }: HomePageProps) {
  useSeo(seo.pages.home)

  return (
    <>
      <Header data={navigation as Navigation} />
      <main>
        <Hero data={hero as HeroType} />
        <About data={about as AboutType} />
        <Services data={services as ServicesType} />
        <Technologies data={technologies as TechnologiesType} />
        <Values data={values as ValuesType} />
        <Process data={process as ProcessType} />
        <Pricing data={pricing as PricingType} />
        <Documents data={documents as DocumentsType} />
        <Contact data={contact as ContactType} footer={footer as FooterType} />
      </main>
      <Footer
        data={footer as FooterType}
        okved={okved as Okved}
        onOpenCookieSettings={onOpenCookieSettings}
      />
    </>
  )
}

function PersonalDataPage() {
  useSeo(seo.pages.personalData)

  return (
    <PersonalData data={personalData as PersonalDataPageType} />
  )
}

function PrivacyPolicyPage() {
  useSeo(seo.pages.privacy)

  return (
    <PrivacyPolicy data={privacyPolicy as PrivacyPolicyPageType} />
  )
}

function MathSinPage() {
  useSeo(seo.pages.mathSin)

  return <MathSin />
}

function App() {
  const { isOpen, accept, decline, reopen } = useCookieConsent()

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage onOpenCookieSettings={reopen} />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/personal-data" element={<PersonalDataPage />} />
        <Route path="/math/sin" element={<MathSinPage />} />
      </Routes>

      <CookieConsent
        data={cookieConsent as CookieConsentType}
        isOpen={isOpen}
        onAccept={accept}
        onDecline={decline}
      />
    </BrowserRouter>
  )
}

export default App
